import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import type { AppConfigDtOverride } from '#/config/types/AppConfig';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';
import { now } from '#/utils/date';

export type WydPageFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  location: SearchLocation | null;
  whatAreYouDoing: string;
  whichIdealistDay: string;
  linkForMoreInfo: string;
  photo: ApiFilestackImageData | null;
  recaptchaKey: number;
  gRecaptchaResponse: unknown;
};

export type WydPageRedirectState = {
  type: 'wyd-page-2nd-step';
  wydPageFormValues: WydPageFormValues;
};

export function isWydPageRedirectState(
  data: unknown,
): data is WydPageRedirectState {
  return Boolean(
    data &&
    typeof data === 'object' &&
    'type' in data &&
    data.type === 'wyd-page-2nd-step',
  );
}

type IdealistDayOption = {
  label: string;
  value: string;
};

export function getNextIdealistDays({
  dtOverride,
}: {
  dtOverride: AppConfigDtOverride;
}): IdealistDayOption[] {
  const date = now({ dtOverride });
  const currentMonth = date.getMonth() + 1; // 1-based
  const currentDay = date.getDate();
  const currentYear = date.getFullYear();

  const options: IdealistDayOption[] = [];
  let month = currentMonth;
  let year = currentYear;

  // If we've already passed this month's Idealist Day, start from next month
  if (currentDay > month) {
    month += 1;
  }

  while (options.length < 6) {
    if (month > 12) {
      month = 1;
      year += 1;
    }

    const label = `${month}/${month}`;
    const value = `${year}-${String(month).padStart(2, '0')}-${String(month).padStart(2, '0')}`;

    options.push({ label, value });
    month += 1;
  }

  return options;
}
